var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalculatorSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.362,
    height: 24,
    viewBox: "0 0 17.362 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calculator-svgrepo-com",
    transform: "translate(-67.766 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8750",
    "data-name": "Path 8750",
    d: "M82.493,0H70.4a2.637,2.637,0,0,0-2.634,2.634V21.366A2.637,2.637,0,0,0,70.4,24H82.493a2.637,2.637,0,0,0,2.634-2.634V2.634A2.637,2.637,0,0,0,82.493,0Zm1.613,21.366a1.615,1.615,0,0,1-1.613,1.613H70.4a1.615,1.615,0,0,1-1.613-1.613V2.634A1.615,1.615,0,0,1,70.4,1.021H82.493a1.615,1.615,0,0,1,1.613,1.613Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8751",
    "data-name": "Path 8751",
    d: "M130.319,68.012h11.234V62.553H130.319Zm1.021-4.438h9.192v3.417H131.34Z",
    transform: "translate(-59.489 -59.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148811",
    "data-name": "Rectangle 148811",
    width: 1.532,
    height: 1.021,
    transform: "translate(71.87 13.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148812",
    "data-name": "Rectangle 148812",
    width: 1.532,
    height: 1.021,
    transform: "translate(75.681 13.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148813",
    "data-name": "Rectangle 148813",
    width: 1.532,
    height: 1.021,
    transform: "translate(79.492 13.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148814",
    "data-name": "Rectangle 148814",
    width: 1.532,
    height: 1.021,
    transform: "translate(71.87 16.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148815",
    "data-name": "Rectangle 148815",
    width: 1.532,
    height: 1.021,
    transform: "translate(75.681 16.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148816",
    "data-name": "Rectangle 148816",
    width: 1.532,
    height: 1.021,
    transform: "translate(79.492 16.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148817",
    "data-name": "Rectangle 148817",
    width: 1.532,
    height: 1.021,
    transform: "translate(71.87 19.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148818",
    "data-name": "Rectangle 148818",
    width: 1.532,
    height: 1.021,
    transform: "translate(75.681 19.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148819",
    "data-name": "Rectangle 148819",
    width: 1.532,
    height: 1.021,
    transform: "translate(79.492 19.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148820",
    "data-name": "Rectangle 148820",
    width: 3.064,
    height: 1.021,
    transform: "translate(78.686 10.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148821",
    "data-name": "Rectangle 148821",
    width: 3.064,
    height: 1.021,
    transform: "translate(71.144 10.47)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorSvgrepoCom);
export default __webpack_public_path__ + "static/media/calculator-svgrepo-com.ef8cf949ecc61da18d3102fc5bc19c60.svg";
export { ForwardRef as ReactComponent };